module.exports = "/static/fonts/OpenSans-SemiboldItalic.eot";